export default __webpack_public_path__ + "static/media/upload-icon.9a840182.svg";